import React from "react";
import { cn } from "@/lib/utils";

export function KpiCard({ label, value, icon: Icon, accent = "primary", sub, testId, delay = 0 }) {
  const accents = {
    primary: "text-blue-500 bg-blue-500/10",
    emerald: "text-emerald-500 bg-emerald-500/10",
    amber: "text-amber-500 bg-amber-500/10",
    rose: "text-rose-500 bg-rose-500/10",
    violet: "text-violet-500 bg-violet-500/10",
    cyan: "text-cyan-500 bg-cyan-500/10",
  };
  return (
    <div data-testid={testId}
      style={{ animationDelay: `${Math.min(delay, 150)}ms` }}
      className="kpi-glow animate-fade-up relative overflow-hidden rounded-xl border border-border bg-card p-5 shadow-sm transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5">
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className="mt-2 font-head text-2xl font-bold tabular leading-none">{value}</p>
          {sub && <p className="mt-1.5 text-xs text-muted-foreground">{sub}</p>}
        </div>
        {Icon && (
          <div className={cn("flex h-10 w-10 shrink-0 items-center justify-center rounded-lg", accents[accent])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
}
